import { Item } from './item';
import { Trigger } from './trigger';
import { ItemDescription } from '../combobox/item-description';
import { ItemLabel } from '../combobox/item-label';
import { Group } from '../combobox/group';
import { GroupLabel } from '../combobox/group-label';
import { Separator } from '../combobox/separator';
import { Collection } from '../combobox/collection';
import { useFilteredItems } from '../combobox/use-filtered-items';
import { SearchableSelect as _SearchableSelect } from './searchable-select';

Trigger.displayName = 'SearchableSelect.Trigger';
Item.displayName = 'SearchableSelect.Item';
ItemLabel.displayName = 'SearchableSelect.ItemLabel';
ItemDescription.displayName = 'SearchableSelect.ItemDescription';
Group.displayName = 'SearchableSelect.Group';
GroupLabel.displayName = 'SearchableSelect.GroupLabel';

/**
 * A searchable single-selection component, with support for
 * a creatable footer action.
 *
 * Prefer `SearchableSelectControl` when using with a standard label and description.
 */
export const SearchableSelect = Object.assign( _SearchableSelect, {
	/**
	 * The trigger button, passed through the `trigger` prop to customize its props
	 * or selected content.
	 */
	Trigger,
	Item,
	ItemLabel,
	ItemDescription,
	Group,
	GroupLabel,
	Separator,
	Collection,
	useFilteredItems,
} );
